import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';
import { AutoText } from '../../../components/pdf/autoText'; 

const styles = StyleSheet.create({
  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  row: {
    flexDirection: 'row',
    borderBottom: '1px solid #000',
  },
  cell: {
    padding: 5,
    borderRight: '1px solid #000',
    verticalAlign: 'middle',
  },
  headerCell: {
    fontWeight: 'bold',
    backgroundColor: '#f2f2f2',
  },
  // Column specific styles
  srNoCell: {
    width: '5%',
  },
  detailsCell: {
    width: '55%',
  },
  pageNoCell: {
    width: '40%',
  },
  combinedCell: {
    width: '95%',
  },
  // Nested table styles with complete borders
  nestedTable: {
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    marginTop: 5,
  },
  nestedRow: {
    flexDirection: 'row',
    borderBottom: '1px solid #000', // Add bottom border to each row
  },
  nestedHeaderCell: {
    fontWeight: 'bold',
    backgroundColor: '#f0f0f0',
    padding: 3,
    fontSize: 9,
    borderRight: '1px solid #000',
    // borderBottom: '1px solid #000', // Ensure header has bottom border
    textAlign: 'center',
  },
  nestedCell: {
    padding: 3,
    height: 20,
    fontSize: 9,
    borderRight: '1px solid #000',
    // borderBottom: '1px solid #000', // Ensure cells have bottom border
    textAlign: 'center',
  },
  // Column widths for nested table
  degreeCell: { width: '25%' },
  boardCell: { width: '25%' },
  classCell: { width: '20%' },
  yearCell: { width: '30%' },
  bulletRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 6,
  },
  bulletSymbol: {
    width: 10,
    fontSize: 10,
    marginRight: 5,
  },
  bulletText: {
    flex: 1,
    fontSize: 10,
    textAlign: 'justify',
    lineHeight: 1.5,
  },
});

const SrScalePage1 = ({ result }) => {
  const tableData = [
    ['१', 'शाळेचे नाव ', result.officeName],
    ['२', `शिक्षकाचे नाव /मुख्याध्यापकाचे नाव`, result.employeeName],
    ['३', `हुद्दा`, result.designation],
    ['४', `जन्मदिनांक`, result.dateOfBirth],
    ['५', `शैक्षणिक पात्रता`, ''],
    ['६', `सलग सेवेचा नेमणूक दिनांक `, result.dateOfJoining],
    ['७', `वेतन बँड व ग्रेड वेतन (जुना /मूळ ६ वा वेतन आयोग ) मधील एकूण सेवा`, `${result.payBand} , ग्रेड वेतन : ${result.gradePay} एकूण सेवा : १२ वर्षे `],
    ['८', `दिनांक ०‍१-०१-२०१६ रोजी किंवा विकल्प दिनांक (.................) रोजी वेतन स्तर मध्ये निश्चित केलेले वेतन `, `${result.payBandPromotion},मूळ वेतन `],
    ['९', `ज्या वेतन स्तरांमध्ये १२ वर्षे सलग अहर्ताकारी सेवा झाली तो वेतन स्तर`, result.payBandPrevious],
    ['१०', `ज्या मूळ वेतन स्तर मध्ये वेतन निश्चित झाले त्या वेतन स्तरांमधील वेतन (वरिष्ठ श्रेणी मिळण्यापूर्वी )`,`${result.payBandPrevious}: ${result.basicPayPrevious}`],
    ['११', `सेवेत सेवा खंड आहे काय? 
        अ ) असल्यास कोठून कोठेपर्यंत 
        ब) सेवा खंड क्षमापित केला आहे काय ? केला असल्यास सत्यप्रत जोडावी `
        , `${result.hasServiceBreak} 
        ${result.serviceBreakDetails}
        ${result.isServiceBreakCondoned}`],
    ['१२', `सेवेत बिनपगारी रजा उपभोगली आहे काय?
        असल्यास तपशील द्यावा`, 
        `${result.hasUnpaidLeave} 
        ${result.unpaidLeaveDetails}`],
    ['१३', `१२ वर्षांची अहर्ताकारी सेवा पूर्ण झाल्याचा 
        (अ) पात्र दिनांक (सेवा खंड व बिनपगारी रजा कालावधी वगळून)
        (ब) विकल्प दिनांक `,
        `
        ${result.dateOfPromotion} 
        ${result.dateOfOption}`],
    // ['१४', `एकाच वेतन स्तरांमध्ये १२ वर्षे सलग अहर्ताकारी सेवा झाल्यामुळे देय वरिष्ठ वेतन श्रेणी/ स्तर`, result.designation],
    // ['१५', `सेवांतर्गत प्रशिक्षण (दाखल्याची सत्यप्रत सोबत जोडावी .)`, result.designation],
  ];

  // Sample data for nested table (qualifications)
  const qualificationData = [
    {
      degree: 'बी.ए.',
      board: 'मुंबई विद्यापीठ',
      class: 'प्रथम श्रेणी',
      year: '२००५'
    },
    {
      degree: 'बी.एड.',
      board: 'पुणे विद्यापीठ',
      class: 'द्वितीय श्रेणी',
      year: '२००७'
    }
  ];

  return (
    <View size="A4" style={style.page}> 
      <Text style={[style.title, style.marathi, { fontSize: 18 }]}>वरिष्ठ वेतन श्रेणी निश्चिती फॉर्म</Text>
      <Text style={[style.subtitle, style.marathi, { fontSize: 10 }]}>शासन निर्णय शिक्षण व सेवायोजन विभाग</Text>
      <View style={style.solidLine}></View>

      {/* References */}
      <View style={{lineHeight: 0.5}}>
        <Text style={[style.paragraph, style.marathi]}>
          १) शालेय शिक्षण व सेवायोजन विभाग क्रमांक चवेआ १०८९/१११ माशि-२ मुंबई-३२ दिनांक २सप्टें.१९८९
        </Text>
        <Text style={[style.paragraph, style.marathi]}>
          २) शालेय शिक्षण व सेवायोजन विभाग क्रमांक चवेआ १०९३/१११ माशि-२ मुंबई-३२ दिनांक ३०ऑक्टो.१९९२
        </Text>
        <Text style={[style.paragraph, style.marathi]}>
          ३) शासन निर्णय क्रमांक एच.एच.स।/१३९०/(८०३०/९०) उ.मा.शि.१ दिनांक १६-१०-१९९२
        </Text>
        <Text style={[style.paragraph, style.marathi]}>
          ४) शालेय शिक्षण व सेवायोजन विभाग क्रमांक पावेआ १०९९/४८/४९ माशि-२ मुंबई-३२ दिनांक १३ मे.१९९२
        </Text>
        <Text style={[style.paragraph, style.marathi]}>
          ५) शालेय शिक्षण क्रीडा विभाग शासन निर्णय क्र.सवेआ १००८/५२१४०८ माशि मुंबई -३२ दिनांक १२ जून २००९
        </Text>
        <Text style={[style.paragraph, style.marathi]}>
          ६) शालेय शिक्षण व क्रीडा विभाग शासन निर्णय क्र : वेतन -१२१९/प्र क्र १९/१९/टीएनटी-3 ,मुंबई दि २२/०२/२०१९
        </Text>
        <Text style={[style.paragraph, style.marathi]}>
          अन्वयें व मनासे नियम ,१९८१च्या ११(२)मधील तुरतुदीप्रमाणे 
        </Text>
      </View>
      <View style={style.solidLine}></View>

      {/* Main Table */}
      <View style={[styles.table, { marginTop: 2 }]}>
        {/* Rows 1-5 */}
        {tableData.slice(0, 5).map(([srNo, details, value], index) => (
          <View style={styles.row} key={`row-${index}`}>
            <AutoText style={[styles.cell, styles.srNoCell]}>{srNo}</AutoText>
            <AutoText style={[styles.cell, styles.detailsCell]}>{details}</AutoText>
            <AutoText style={[styles.cell, styles.pageNoCell]}>{value}</AutoText>
          </View>
        ))}

        {/* Special Row 5 with nested table */}
        <View style={styles.row}>
        <AutoText style={[styles.cell, styles.srNoCell]}></AutoText>

          <View style={[styles.cell, styles.combinedCell, { borderRight: '1px solid #000' }]}>
          
            {/* Nested Table with complete borders */}
            <View style={styles.nestedTable}>
              {/* Header Row */}
              <View style={styles.nestedRow}>
                <AutoText style={[styles.nestedHeaderCell, styles.degreeCell]}>पदवी</AutoText>
                <AutoText style={[styles.nestedHeaderCell, styles.boardCell]}>बोर्ड / विद्यापीठ</AutoText>
                <AutoText style={[styles.nestedHeaderCell, styles.classCell]}>वर्ग</AutoText>
                <AutoText style={[styles.nestedHeaderCell, styles.yearCell]}>उत्तीर्ण दिनांक / वर्ष</AutoText>
              </View>
              
              {/* Data Rows */}
              {qualificationData.map((qual, idx) => (
                <View style={styles.nestedRow} key={`qual-${idx}`}>
                  <AutoText style={[styles.nestedCell, styles.degreeCell]}></AutoText>
                  <AutoText style={[styles.nestedCell, styles.boardCell]}></AutoText>
                  <AutoText style={[styles.nestedCell, styles.classCell]}></AutoText>
                  <AutoText style={[styles.nestedCell, styles.yearCell]}></AutoText>
                </View>
              ))}
              

            </View>
          </View>
        </View>

        {/* Rows 6-15 */}
        {tableData.slice(5).map(([srNo, details, value], index) => (
          <View style={styles.row} key={`row-${index + 5}`}>
            <AutoText style={[styles.cell, styles.srNoCell]}>{srNo}</AutoText>
            <AutoText style={[styles.cell, styles.detailsCell]}>{details}</AutoText>
            <AutoText style={[styles.cell, styles.pageNoCell]}>{value}</AutoText>
          </View>
        ))}
      </View>
    </View>
  );
};

export default SrScalePage1;